import { ReactNode } from 'react'

import { cn } from 'src/utils'

/** FMCSA SAFER carrier snapshot — the public record behind a DOT number. */
export const saferSnapshotUrl = (dotNumber: string) =>
  `https://safer.fmcsa.dot.gov/query.asp?query_type=queryCarrierSnapshot&query_param=USDOT&query_string=${encodeURIComponent(
    dotNumber.trim()
  )}`

export interface DotNumberLinkProps {
  dotNumber?: string | null
  /** Defaults to the DOT number itself. */
  children?: ReactNode
  className?: string
}

/**
 * Links a DOT number to its FMCSA SAFER snapshot, so anyone looking at a thin
 * directory record can check it against the public one without retyping the
 * number. Renders nothing when there is no DOT number — the caller decides what
 * an absent number should look like.
 */
const DotNumberLink = ({
  dotNumber,
  children,
  className,
}: DotNumberLinkProps) => {
  const trimmed = dotNumber?.trim()
  if (!trimmed) return null

  return (
    <a
      href={saferSnapshotUrl(trimmed)}
      target="_blank"
      rel="noopener noreferrer"
      title={`Look up DOT ${trimmed} on FMCSA SAFER`}
      className={cn(
        'text-doubleNickel-brand-600 hover:underline',
        !children && 'font-mono',
        className
      )}
    >
      {children ?? trimmed}
    </a>
  )
}

export default DotNumberLink
